/*
 * The closing band keeps this page's 84px section rhythm on BOTH sides, rather than zeroing its top
 * padding as the shared default does — otherwise it sits flush against the dark "Data digger"
 * section above. Its inner padding also runs 60px against the shared 56px.
 */
.cta {
  --cta-section-padding: 84px 0;
  --cta-band-padding: 60px 40px;
}

/* Same breakpoint and value as every other section on this page. */
@media (max-width: 768px) {
  .cta {
    --cta-section-padding: 56px 0;
  }
}
